import type { FeedbackRequest, FeedbackResponse } from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { FeedbackRequest, FeedbackResponse };

export async function submitFeedback(payload: FeedbackRequest): Promise<FeedbackResponse> {
  return apiRequest<FeedbackResponse>("/feedback", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
